import React from 'react';
import { connect } from 'react-redux';
import * as reducers from '../../store/reducers';
import * as usersActions from '../../store/users/actions';

import Button from 'Components/Button';
import CollectionListItem from 'Components/CollectionListItem';

const SchoolsListItem = props => {
  const isActive = props.id === props.activeSchoolId;
  const actionLabel = isActive ? 'Active School' : 'Make Active';
  const buttonType = isActive ? 'secondary-transparent' : 'secondary-mono';
  const actionButton = (
    <Button
      label={actionLabel}
      buttonType={buttonType}
      additionalClasses=" CollectionListItem__action-button"
      noLink={isActive}
      clickHandler={() =>
        !isActive ? props.changeActiveSchool(props.id) : null
      }
    />
  );

  return (
    <CollectionListItem {...props} type="schools" actionButton={actionButton} />
  );
};

const mapStateToProps = state => {
  return {
    activeSchoolId: reducers.getActiveSchoolId(state),
  };
};

export default connect(mapStateToProps, usersActions)(SchoolsListItem);
